import { render } from "./FlightDepartures.vue?vue&type=template&id=7abb857a&scoped=true&ts=true"
import script from "./FlightDepartures.vue?vue&type=script&lang=ts"
export * from "./FlightDepartures.vue?vue&type=script&lang=ts"

import "./FlightDepartures.vue?vue&type=style&index=0&id=7abb857a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abb857a"]])

export default __exports__